/* eslint-disable @typescript-eslint/no-explicit-any */
/* Contract Employee / Consultant — Contract Details. A single Contract Type
   choice (With GST / Without GST) replaces the two duplicate legacy blocks;
   only the chosen configuration is shown. Contract value and monthly payout
   auto-fill each other (value ÷ 12). GST % shows only for GST contracts. */
import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "components/Input";
import { preventSpecialCharKeyDown } from "util/preventSpecialCharInput";
import { SectionCard, SegmentedControl, HelperText } from "./_controls";

const ContractorContractSection = () => {
  const { watch, setValue } = useFormContext();
  const contractType = watch("contractType");
  const isGst = contractType === "GST";

  const syncFromContract = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = parseFloat(e.target.value);
    if (Number.isFinite(v)) {
      setValue("monthlyPayout", Math.round((v / 12) * 100) / 100, { shouldValidate: true, shouldDirty: true });
    }
  };
  const syncFromPayout = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = parseFloat(e.target.value);
    if (Number.isFinite(v)) {
      setValue("contractValue", Math.round(v * 12 * 100) / 100, { shouldValidate: true, shouldDirty: true });
    }
  };

  return (
    <SectionCard title="Contract Details" subtitle="Contract-based compensation and billing.">
      {/* Contract Type — decides whether GST applies */}
      <div className="mb-4">
        <SegmentedControl
          name="contractType"
          label="Contract Type"
          required
          options={[
            { value: "GST", label: "With GST" },
            { value: "NON_GST", label: "Without GST" },
          ]}
        />
        <HelperText>
          {isGst ? "GST is applicable on this contract." : "GST is not applicable on this contract."}
        </HelperText>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
        <Input
          compact
          name="contractValue"
          label="Contract Value  ·  ₹ / year"
          type="number"
          required
          onChange={syncFromContract}
          onKeyDown={preventSpecialCharKeyDown}
        />
        <div>
          <Input
            compact
            name="monthlyPayout"
            label="Monthly Payout  ·  ₹ / month"
            type="number"
            required
            onChange={syncFromPayout}
            onKeyDown={preventSpecialCharKeyDown}
          />
          <HelperText>Auto-filled as contract value ÷ 12; editable.</HelperText>
        </div>

        {isGst && (
          <div>
            <Input
              compact
              name="gstPercentage"
              label="GST %"
              type="number"
              required
              onKeyDown={preventSpecialCharKeyDown}
            />
            <HelperText>Added on top of the payout for the invoice total.</HelperText>
          </div>
        )}
      </div>
    </SectionCard>
  );
};

export default ContractorContractSection;
